import React, {useState} from "react";
import {connect} from 'react-redux';
import {Button, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import isEmpty from 'lodash/isEmpty';
import {Trans, useTranslation} from "react-i18next";
import get from 'lodash/get';

import {setRegisterFormErrors, touchRegisterForm} from "../../../actions/Auth";
import {concatURL, renderErrorsAsHTML} from '../../../Components/utils'
import {register} from "../../../thunks/Auth";


const FullForm = (
    {
        errors,
        phone_number,
        code,
        referral_code,
        register,
        setRegisterFormErrors,
        touchRegisterForm,
    }
) => {
    const {t, i18n} = useTranslation();

    // State
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordrep, setPasswordrep] = useState('');
    const [check, setCheck] = useState(false);

    const sendRegisterRequest = (e) => {
        e.preventDefault();

        let errors = {};

        if (password !== passwordrep) {
            errors = {
                ...errors,
                password: [t('auth.register.full_form.error_passwords_not_equal', 'Passwords are mismatched')],
                passwordrep: true,
            };
        }

        if (!check) {
            errors = {
                ...errors,
                check: [t('auth.register.full_form.error_rules_not_agreed', 'You have to agree with the privacy policy')],
            };
        }

        if (!isEmpty(errors)) {
            setRegisterFormErrors(errors);
            return;
        }

        register(
            email,
            phone_number,
            code,
            password,
            passwordrep,
            check,
            referral_code,
            i18n.languages[0],
            (response) => {
                window.location.href = concatURL(window.location.href, '../../login');
            }
        );
    };

    return <Form onSubmit={sendRegisterRequest} autoComplete="on">
        <Row form>
            <Col md={6}>
                <FormGroup>
                    <Label for="exampleEmail">
                        <span className="text-danger">*</span>
                        {' '}{t('auth.register.full_form.label_email', 'Email')}
                    </Label>
                    <Input type="email" name="email"
                           id="exampleEmail"
                           placeholder={t('auth.register.full_form.label_email', 'Email')}
                           required
                           value={email}
                           onChange={e => setEmail(e.target.value)}
                           invalid={get(errors, 'email') !== undefined}
                           onClick={touchRegisterForm}/>
                </FormGroup>
            </Col>
            <Col md={12} className='text-danger'>
                {renderErrorsAsHTML(get(errors, 'email'))}
            </Col>
        </Row>
        <Row form>
            <Col md={6}>
                <FormGroup>
                    <Label for="examplePassword">
                        <span className="text-danger">*</span>
                        {' '}{t('auth.register.full_form.label_password', 'Password')}
                    </Label>
                    <Input type="password"
                           name="password"
                           id="examplePassword"
                           placeholder={t('auth.full_form.placeholder_password', 'Password')}
                           required
                           value={password}
                           onChange={e => setPassword(e.target.value)}
                           invalid={get(errors, 'password') !== undefined}
                           onClick={touchRegisterForm}/>
                </FormGroup>
            </Col>
            <Col md={6}>
                <FormGroup onClick={touchRegisterForm}>
                    <Label for="examplePasswordRep">
                        <span className="text-danger">*</span>
                        {' '}{t('auth.register.full_form.label_password_rep', 'Repeat password')}
                    </Label>
                    <Input type="password"
                           name="passwordrep"
                           id="examplePasswordRep"
                           placeholder={t('auth.full_form.placeholder_password_rep', "Repeat password")}
                           value={passwordrep}
                           required
                           onChange={e => setPasswordrep(e.target.value)}
                           invalid={get(errors, 'passwordrep') !== undefined}
                           onClick={touchRegisterForm}/>
                </FormGroup>
            </Col>
            <Col md={12} className='text-danger'>
                {renderErrorsAsHTML(get(errors, 'password'))}
            </Col>
        </Row>

        <FormGroup className="mt-3"
                   check
                   onClick={touchRegisterForm}>
            <Input type="checkbox"
                   name="check"
                   id="exampleCheck"
                   invalid={get(errors, 'passwordrep') !== undefined}
                   value={check}
                   onChange={e => {
                       setCheck(e.target.checked)
                   }}/>
            <Label for="exampleCheck" check>
                <Trans t={t} i18nKey='auth.register.full_form.label_rules'>
                    I agree to the {' '}
                    <a href={t('auth.register.full_form.href_terms', '/terms')} rel="noopener noreferrer" target="_blank">
                        Terms of Service
                    </a>
                    {' '} and {' '}
                    <a href={t('auth.register.full_form.href_privacy_policy', '/privacy-policy')}
                       target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </a>
                </Trans>
            </Label>
        </FormGroup>

        <Col md={12} className='text-danger mt-1'>
            {renderErrorsAsHTML(get(errors, 'check'))}
        </Col>

        <div className="mt-4 text-danger">
            {renderErrorsAsHTML(get(errors, 'common'))}
        </div>

        <Button color="primary"
                className="btn-wide btn-pill btn-shadow btn-hover-shine"
                size="lg">
            {t('auth.register.full_form.button_submit', 'Register')}
        </Button>
    </Form>;
};


const mapStateToProps = state => ({
    errors: state.Auth.register.errors,
    phone_number: state.Auth.register.phone_number,
    code: state.Auth.register.code,
    referral_code: state.Auth.register.ref
});

const mapDispatchToProps = dispatch => ({
    register: (email, phone_number, code, password, passwordrep, check, referral_code, lang_code, callback) => dispatch(register(email, phone_number, code, password, passwordrep, check, referral_code, lang_code, callback)),
    setRegisterFormErrors: (errors) => dispatch(setRegisterFormErrors(errors)),
    touchRegisterForm: () => dispatch(touchRegisterForm()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FullForm);
